import { getUserData } from "../../../../services/API";

/**
 * Checks if the audio is disabled for the current district
 * @returns {boolean}
 */
export default function isAudioDisabledDistrict() {
  const userData = getUserData();
  const audioDisabledDistricts = userData?.appSettings?.audioDisabledDistricts;
  const districtId = userData?.districtId;

  if(!audioDisabledDistricts) return false
  return audioDisabledDistricts?.includes(districtId);
}
